<template>
    <v-dialog v-model="pressSheet" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">The Press Sheet</span>
          </v-card-title>
          <v-card-text>
            <v-layout row>
              <v-flex xs5>
                <v-autocomplete single-line
                      v-model = "selectedLot"
                      :items='lots'
                      item-text='lotNumber'
                      item-value='lotNumber'
                      label='Lot'
                    >
                    <template slot="item" slot-scope="data">
                      {{data.item.lotNumber}} - {{ data.item.description }}
                    </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs3>
                <v-select single-line
                  v-model = "timeSlot"
                  label="Time Slot"
                  :items = 'timeSlotList'>
                </v-select>
              </v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs2>
                <v-select single-line
                  v-model = "press"
                  label="Press"
                  :items = 'pressChoices'>
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-select
                    :items="pressTypes"
                    v-model="pressType"
                    label="Press Type">
                </v-select>
              </v-flex>
              <v-flex xs1>
              </v-flex>
              <v-flex xs6>
                  <v-select
                    :items="pressPrograms"
                    v-model="program"
                    label="Press Program">
                  </v-select>
              </v-flex>
              </v-layout>
                <v-layout row>
                  <v-select
                    :items="pressCuts[program]"
                    v-model="pressCut"
                    label="Press Cut">
                  </v-select>
                </v-layout>
                <v-layout row>
                  <v-text-field
                    label="Duration"
                    v-model.number="duration">
                  </v-text-field>
                  <v-flex xs1 v-if="program=='PRESS_TO_BBL'"></v-flex>
                  <v-text-field v-if="program=='PRESS_TO_BBL'"
                    label="Fill Level"
                    v-model.number="fillLevel">
                  </v-text-field>
                </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-textarea outline
                rows="6"
                auto-grow
                outlined
                row-height="15"
                label="Comments"
               v-model="comments"></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="close">Cancel</v-btn>
            <!-- <v-btn color="primary" v-if="selectedLot && !editing" flat @click.native="save">Save</v-btn>
            <v-btn color="primary" v-if="selectedLot && editing" flat @click.native="save">Update</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
  </template>

<script>

import moment from 'moment'
import axios from 'axios'
import myMixins from '../mixins/myMixins'

export default {
  props: ['wos', 'date'],
  mixins: [myMixins],
  data () {
    return {
      editing: false,
      comments: '',
      duration: 0,
      fillLevel: 0,
      pressCut: 0,
      program: '',
      pressType: 'PRESS_TO_TANK',
      pressTypes: ['PRESS_TO_BBL', 'PRESS_TO_TANK'],
      pressPrograms: ['WC HIGH PRESSURE', 'WC LOW PRESSURE', 'CRUSHED WHITES', 'DRAINED REDS'],
      pressCuts: {
        'WC HIGH PRESSURE': [0, 0.2, 0.4, 0.6, 0.8, 1.1, 1.4, 1.7, 2.0],
        'WC LOW PRESSURE': [0, 0.2, 0.4, 0.6, 0.8, 1.1, 1.4],
        'CRUSHED WHITES': [0, 0.2, 1.0, 1.8],
        'DRAINED REDS': [0, 0.2, 0.4, 0.6, 0.8, 1.1, 1.4, 1.7, 2.0]
      },
      showDatePicker: false,
      pressSheet: false,
      pressSheetId: -1,
      pressDate: '',
      press: '',
      pressChoices: ['SMALL', 'MEDIUM', 'LARGE'],
      selectedLot: '',
      timeSlot: '',
      timeSlotList: ['MORNING', 'NOON', 'EVENING', 'EXTRA'],
      newPressWO: {},
      picker: new Date().toISOString().substr(0, 10),
      pressIds: {
        SMALL: 2,
        MEDIUM: 635,
        LARGE: 20
      },
      extra: {
        small: {},
        medium: {},
        large: {}
      },
      morning: {
        small: {},
        medium: {},
        large: {}
      },
      noon: {
        small: {},
        medium: {},
        large: {}
      },
      evening: {
        small: {},
        medium: {},
        large: {}
      }
    }
  },
  watch: {
    wos (nv, ov) {
      this.morning.small = {}
      this.morning.medium = {}
      this.morning.large = {}
      this.noon.small = {}
      this.noon.medium = {}
      this.noon.large = {}
      this.evening.small = {}
      this.evening.medium = {}
      this.evening.large = {}
      this.extra.small = {}
      this.extra.medium = {}
      this.extra.large = {}

      nv.forEach(wo => {
        switch (wo.assetId) {
          case 2:
            switch (wo.WorkOrder.startSlot) {
              case 'MORNING' : this.morning.small = wo; break
              case 'NOON' : this.noon.small = wo; break
              case 'EVENING' : this.evening.small = wo; break
              case 'EXTRA' : this.extra.small = wo; break
            }
            break
          case 20:
            switch (wo.WorkOrder.startSlot) {
              case 'MORNING' : this.morning.large = wo; break
              case 'NOON' : this.noon.large = wo; break
              case 'EVENING' : this.evening.large = wo; break
              case 'EXTRA' : this.extra.large = wo; break
            }
            break
          case 635:
            switch (wo.WorkOrder.startSlot) {
              case 'MORNING' : this.morning.medium = wo; break
              case 'NOON' : this.noon.medium = wo; break
              case 'EVENING' : this.evening.medium = wo; break
              case 'EXTRA' : this.extra.medium = wo; break
            }
        }
      })
    }
  },
  computed: {
    clientcode () {
      return this.$store.state.client.CODE
    },
    lots () {
      return this.$store.state.lotsForVintage
    }
  },
  methods: {
    addButtonTapped (item) {
      this.selectedLot = ''
      this.program = this.pressPrograms[0]
      this.editing = false

      this.timeSlot = item.slot
      this.press = item.press
      this.pressDate = item.date
      this.pressSheet = true
    },
    close () {
      this.pressSheet = false
    },
    save () {
      if (this.editing) {
        let wo = {
          lot: this.selectedLot,
          'SCPs': [],
          type: 'PRESSOFF',
          date: this.pressDate,
          startSlot: this.timeSlot,
          clientCode: this.clientcode,
          requestor: this.$store.state.user.username,
          workPerformedBy: 'CCC',
          status: 'ASSIGNED'
        }
        let url = process.env.VUE_APP_BACKEND+'workorders/' + this.workOrderId
        axios
          .put(url, wo)
          .then(respnse => {
            url = process.env.VUE_APP_BACKEND+'reservations/' + this.reservationId
            let assetId = 0
            switch (this.press) {
              case 'SMALL' : assetId = 2; break
              case 'MEDIUM' : assetId = 635; break
              case 'LARGE' : assetId = 20
            }
            let reservation = {
              assetId: assetId
            }
            axios
              .put(url, reservation)
              .then(response => {
                url = process.env.VUE_APP_BACKEND+'pressprograms/' + this.pressSheetId
                let pressSheet = {
                  program: this.program,
                  woid: woid,
                  pressType: this.pressType,
                  fillLevel: this.fillLevel,
                  pressCut: this.pressCut,
                  description: this.comments,
                  pressDuration: this.duration
                }
                axios
                  .put(url, pressSheet)
                  .then(response => {
                    this.editing = false
                    this.pressSheet = false
                    this.$emit('woChanged')
                  })
              })
          })
        return
      }
      let newWorkOrder = {
        Lot: {
          lotNumber: this.selectedLot
        },
        'SCPs': [],
        type: 'PRESSOFF',
        date: this.pressDate,
        startSlot: this.timeSlot,
        clientCode: this.clientcode,
        requestor: this.$store.state.user.username,
        workPerformedBy: 'CCC',
        status: 'ASSIGNED'
      }
      let url = process.env.VUE_APP_BACKEND+'workorders'
      let woid = -1
      axios
        .post(url, newWorkOrder) // create workorder first
        .then(response => {
          woid = response.data.data.id // remember workorder id to use to create reservation and pressprogram
          let reservation = {
            woid: woid,
            Asset: {
              id: this.pressIds[this.press]
            }
          }
          let url = process.env.VUE_APP_BACKEND+'reservations'
          axios
            .post(url, reservation)
            .then(response => {
              this.$emit('woChanged')
              this.pressSheet = false
            })

          url = process.env.VUE_APP_BACKEND+'pressprograms'
          let pressSheet = {
            program: this.program,
            woid: woid,
            pressType: this.pressType,
            fillLevel: this.fillLevel,
            pressCut: this.pressCut,
            description: this.comments,
            pressDuration: this.duration
          }
          axios
            .post(url, pressSheet)
            .then(response => {

            })
        })
    },
    hasPermission () {
      if (this.isStaff() === true) return true
      return false
    },
    setData (value) {
      this.reservationId = value.id
      this.pressDate = value.WorkOrder.dueDate
      this.workOrderId = value.WorkOrder.id
      this.pressSheetId = value.WorkOrder.PressProgram.id
      this.program = value.WorkOrder.PressProgram.program
      this.pressType = value.WorkOrder.PressProgram.pressType
      this.fillLevel = value.WorkOrder.PressProgram.fillLevel
      this.pressCut = value.WorkOrder.PressProgram.pressCut
      this.comments = value.WorkOrder.PressProgram.description
      this.duration = value.WorkOrder.PressProgram.pressDuration
      this.selectedLot = value.WorkOrder.lot
      this.timeSlot = value.WorkOrder.startSlot
      switch (value.assetId) {
        case 2: this.press = 'SMALL'; break
        case 20: this.press = 'LARGE'; break
        case 635: this.press = 'MEDIUM'; break
      }
    },
    goto (timeFrame, pressSize) {
      console.log(timeFrame + ' ' + pressSize)
      console.log(JSON.stringify(this.morning.small, null, 2))
      let data = {}
      switch (timeFrame) {
        case 'MORNING':
          switch (pressSize) {
            case 'SMALL' : {
              this.setData(this.morning.small)
              break
            }
            case 'MEDIUM' : {
              this.setData(this.morning.medium)
              break
            }
            case 'LARGE' : {
              this.setData(this.morning.large)
              break
            }
          }
          break
        case 'NOON':
          switch (pressSize) {
            case 'SMALL' : {
              this.setData(this.noon.small)
              break
            }
            case 'MEDIUM' : {
              this.setData(this.noon.medium)
              break
            }
            case 'LARGE' : {
              this.setData(this.noon.large)
              break
            }
          }

          break
        case 'EVENING':
          switch (pressSize) {
            case 'SMALL' : {
              this.setData(this.evening.small)
              break
            }
            case 'MEDIUM' : {
              this.setData(this.evening.medium)
              break
            }
            case 'LARGE' : {
              this.setData(this.evening.large)
              break
            }
          }

          break
        case 'EXTRA':
          console.log(JSON.stringify(this.extra, null, 2))
          switch (pressSize) {
            case 'SMALL' : {
              this.setData(this.extra.small)
              break
            }
            case 'MEDIUM' : {
              this.setData(this.extra.medium)
              break
            }
            case 'LARGE' : {
              this.setData(this.extra.large)
              break
            }
          }
      }
      this.pressSheet = true
      this.editing = true
    },
    nextDay (wo) {
      var newDate = moment(wo.date).add(1, 'day')
      wo.date = newDate.toDate()
      axios
        .put(process.env.VUE_APP_BACKEND+'workorders/' + wo.id, wo)
        .then((response) => {
          this.$emit('woChanged', wo)
        })
    },
    previousDay (wo) {
      var newDate = moment(wo.date).subtract(1, 'day')
      wo.date = newDate.toDate()
      axios
        .put(process.env.VUE_APP_BACKEND+'workorders/' + wo.id, wo)
        .then((response) => {
          this.$emit('woChanged', wo)
        })
    }

  }
}
</script>
<style>
</style>
